export class ModalSitePickerDisplayTextPropsApi {
    /**
     * The label on the site picker open button
     */
    sitePickerButtonLabel: string = 'Cinemas'
    /**
     * The message shown before the site picker open button
     */
    sitePickerButtonMessage: string = 'Show me times for'
    /**
     * Shows the number of unselected sites being displayed and the maximum number of sites that can be selected.
     */
    siteCountLabel: string = 'Showing ${siteCount} locations (select up to ${maximumSelectedSites})'
    /**
     * Shows the number of unselected sites being displayed and a message that the maximum number of sites have been selected.
     */
    siteCountLabelMaximumSelected: string = 'Showing ${siteCount} locations (maximum selected)'
    /**
     * The placeholder shown in the search input field.
     */
    searchInputPlaceholder: string = 'Search by name or location'
    /**
     * The message shown when there are no sites found for the current search term.
     */
    noSitesFoundForSearchTermMessage: string = "Sorry, we couldn't find any locations matching '${searchTerm}'."
    /**
     * Title displayed when data failed to load from the API.
     */
    failedToLoadDataTitle: string = 'Sorry, something went wrong.'
    /**
     * Message displayed when data failed to load from the API.
     */
    failedToLoadDataMessage: string = 'Refresh your browser to try loading cinemas again.'
    /**
     * Label for 'Save your cinemas' button
     */
    saveCinemasLabel: string = 'Save your cinemas'
    /**
     * Label that displays in modal header
     *
     * Not displayed when left empty.
     */
    modalHeading?: string
}
